<template>
  <VExpansionPanels multiple flat>
    <VacancyFaq
      v-for="faq of vacancy.faq"
      :key="faq.id"
      :faq="faq"
      :vacancy="vacancy"
    />
  </VExpansionPanels>
</template>

<script>
import VacancyFaq from './VacancyFaq.vue';

export default {
  name: 'VacancyFaqList',
  components: { VacancyFaq },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
};
</script>
